import OpenReplay from './OpenReplay';

export default OpenReplay;
